module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjgiIHZpZXdCb3g9IjAgMCA4IDgiPgogICAgPHBhdGggZmlsbD0iI2E4YWFiNyIgZmlsbC1ydWxlPSJub256ZXJvIiBkPSJNNCAzLjE5TDcuMTkgMCA4IC44MSA0LjgxIDQgOCA3LjE5IDcuMTkgOCA0IDQuODEuODEgOCAwIDcuMTkgMy4xOSA0IDAgLjgxLjgxIDAgNCAzLjE5eiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/close-dark.svg
// module id = ./src/assets/close-dark.svg
// module chunks = 0